module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2f"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/frontm01#read",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Read What People Are Saying")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#int"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("Introduction")]), _c('br'), _vm._v("Opportunities in Perpetually Gut-Wrenching Times — for Guerrillas Only!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01#part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART I:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part01#part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GET COMBAT-READY")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter01#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 1")]), _c('br'), _vm._v("Your Chaotic Career Map: Stop Being Attached to the Concept of a Job")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 2")]), _c('br'), _vm._v("The Eleven Guerrilla Mindsets for Career Success")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 3")]), _c('br'), _vm._v("Character and Values Matter More than Ever")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 4")]), _c('br'), _vm._v("A Dream Worth Fighting For")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 5")]), _c('br'), _vm._v("Spike in These Two Areas and Never Worry Again")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 6")]), _c('br'), _vm._v("Your One-Page Career Plan")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 7")]), _c('br'), _vm._v("Why Strengths Are Not Enough—What if You Have Distracting,  Annoying, or Disturbing Behaviors and Don’t Even Know It?")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 8")]), _c('br'), _vm._v("Eliminate the Biggest Reason You Won’t Succeed")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 9")]), _c('br'), _vm._v("Cash Is a Career Competitive Advantage")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 10")]), _c('br'), _vm._v("The Three Steps to Get into the Opportunity Flow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THIRTEEN PERSPECTIVES TO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part02#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CONTROL THE CAREER BATTLEFIELD")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 11")]), _c('br'), _vm._v("Why These Thirteen Perspectives Are Crucial for Career Success")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 12")]), _c('br'), _vm._v("Lemming and Bubble Radar—Which Apparent Opportunities Will End Soon, and Badly for Those Who Come Late?")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 13")]), _c('br'), _vm._v("Market Researcher—Matching Your Talents and Passion to Demand")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 14")]), _c('br'), _vm._v("Investor—Is This Opportunity Solid?")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 15")]), _c('br'), _vm._v("Risk Manager/Oil Driller—How Can I Maximize Upside and Minimize Downside?")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 16")]), _c('br'), _vm._v("Chess Master—What’s My Best Next Move?")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 17")]), _c('br'), _vm._v("Negotiator/Dealmaker—How Can I Gain an Edge?")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 18")]), _c('br'), _vm._v("Talent Scout—Who Can Help Me Win?")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 19")]), _c('br'), _vm._v("Business Developer—How Can I Build a Long-Term Relationship Based on Trust and Value?")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 20")]), _c('br'), _vm._v("Politician—How Do I Gain More Power?")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 21")]), _c('br'), _vm._v("Influencer—What’s In It for Them That Gets Me What I Want, Too?")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 22")]), _c('br'), _vm._v("Leverage Builder—How Can I Achieve More with Less Effort?")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 23")]), _c('br'), _vm._v("Improvisational Actor—How Can I Use Creativity, Resourcefulness, and Agility to Get What I Want?")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 24")]), _c('br'), _vm._v("Drill Sergeant—How Do I Give Myself a Kick in the Pants When Required?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03#part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part03#part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE AGILE CAREER GUERRILLA")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 25")]), _c('br'), _vm._v("How to Be an Agile Career Guerrilla")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 26")]), _c('br'), _vm._v("When to Make a Change, and When Not To")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 27")]), _c('br'), _vm._v("Why Business Owners Need to Have Backup Plans, Too")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 28")]), _c('br'), _vm._v("Three Rules for Making a Smooth Transition")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 29")]), _c('br'), _vm._v("The Flip-the-Switch Business I—Online Information Publisher")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 30")]), _c('br'), _vm._v("The Flip-the-Switch Business II—Consultant/Freelancer")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 31")]), _c('br'), _vm._v("The Flip-the-Switch Business III—Firm Builder")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 32")]), _c('br'), _vm._v("The Flip-the-Switch Business IV—The LFC/LBE Business")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 33")]), _c('br'), _vm._v("The Anti Flip-the-Switch Business—The Long, Patient Way to a Bulletproof Career")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 34")]), _c('br'), _vm._v("The Agile Interim Executive or Manager")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 35")]), _c('br'), _vm._v("Go Global!")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 36")]), _c('br'), _vm._v("Finesse a Change in Industry, Function, or Company Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter37#ch37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 37")]), _c('br'), _vm._v("Become Dean of Your Private Career University and Use the Back-to-School Trump Card")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter38#ch38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 38")]), _c('br'), _vm._v("Recharge and Reinvent Yourself with a Sabbatical")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter39#ch39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 39")]), _c('br'), _vm._v("Advanced Career Agility: Form an Acquisition or Startup Team")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter40#ch40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 40")]), _c('br'), _vm._v("What About Just Getting a New Job in the Same Field?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part04#part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV:")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part04#part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COMMON COMBAT SITUATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter41#ch41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 41")]), _c('br'), _vm._v("Seven Steps to Success During Your First Ninety Days in a New Role")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter42#ch42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 42")]), _c('br'), _vm._v("Eleven Career Success Principles for Students and New Graduates")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter43#ch43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 43")]), _c('br'), _vm._v("Opportunities for the Stay-at-Home Mom or Dad")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter44#ch44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 44")]), _c('br'), _vm._v("Going Back to Work After a Long Absence")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter45#ch45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 45")]), _c('br'), _vm._v("Unfriendly Fire and Ambushes: Saboteurs, Snipers, Jerks, Peter Principle Poster Children, Nepotism, and Difficult Bosses")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter46#ch46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 46")]), _c('br'), _vm._v("Discrimination, Harassment, Fraud, Price Fixing, Insider Trading, Kickbacks, and Other Illegal Behaviors")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter47#ch47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("CHAPTER 47")]), _c('br'), _vm._v("What to Do After a Major Failure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/conclusion#con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Your Next Steps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/about#abo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/claim#cla",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Claim Your Free Bonus Worth $497!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0